module.exports = __webpack_public_path__ + "static/media/almog.2cf9a1e4.PNG";